import React from 'react'

const Contact = () => {
  return (
    <div name='contact' className='w-full h-full bg-[#0a192f] flex justify-center  '>
  
        <form method='POST' action="https://getform.io/f/82fdd372-0fee-4f14-b47d-a3e6c3cde66a" className='flex flex-col max-w-[600px] w-full'>
            <div className='pb-30 mt-10'>
                <p className=' text-4xl font-bold inline border-b-4 border-pink-600 text-gray-300 justify-center'>Contact</p>
                <p className='text-gray-300 py-4'>// Submit the form below or shoot me an email - ghoshanisha2002@gmail.com</p>
            </div>
            <input className='bg-[#ccd6f6] p-2' type="text" placeholder='Name' name='name' />
            <input className='my-4 p-2 bg-[#ccd6f6]' type="email" placeholder='Email' name='email' />
            <textarea className='bg-[#ccd6f6] p-2' name="message" rows="10" placeholder='Message'></textarea>
            <button className='text-white border-2 bg-pink-600 border-pink-600 px-4 py-3 my-8 mx-auto flex items-center'>Let's Collaborate</button>
        </form>
    </div>
  )
}

export default Contact